// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3LIOX","range":"MonthRangeSwitch_range__f5cTp","disabled":"MonthRangeSwitch_disabled__5GbDd"};